import { createFileRoute, redirect } from '@tanstack/react-router';
import AdministratorControlPage from '../../features/adminPanel/pages/administratorControlPage';
import { administratorApi } from '../../features/adminPanel/services/api/administratorApi';
import { administratorKeys } from '../../features/adminPanel/services/queries/administratorQueries';

export const Route = createFileRoute('/_app/administratorControlPanel')({
  beforeLoad: async (ctx) => {
    const adminParam = await ctx.context.queryClient.ensureQueryData({
      queryKey: administratorKeys.param('Administrator'),
      queryFn: () => administratorApi.getAdminParameters('Administrator'),
    });

    if (
      typeof adminParam !== 'object' ||
      adminParam === null ||
      typeof adminParam === 'boolean'
    ) {
      throw redirect({
        to: '/chat',
      });
    }
  },
  loader: async ({ context }) => {
    const bannerMessageData = await context.queryClient.ensureQueryData({
      queryKey: administratorKeys.param('Banner'),
      queryFn: () => administratorApi.getAdminParameters('Banner'),
      staleTime: Infinity,
    });

    const landingMessageData = await context.queryClient.ensureQueryData({
      queryKey: administratorKeys.param('Landing'),
      queryFn: () => administratorApi.getAdminParameters('Landing'),
      staleTime: Infinity,
    });

    const surveyData = await context.queryClient.ensureQueryData({
      queryKey: administratorKeys.param('Survey'),
      queryFn: () => administratorApi.getAdminParameters('Survey'),
      staleTime: Infinity,
    });
    return {
      bannerMessageData,
      landingMessageData,
      surveyData,
    };
  },
  component: AdministratorControlPage,
});
